import type { VoidFunctionComponent } from 'react';

import StopComparing from './StopComparing';

import styles from '../IssueComparison.module.less';

const ComparisonHeader: VoidFunctionComponent = () => {
  return (
    <header className={styles.headerCard}>
      {/* We use the container container-responsive class to ensure this lines up with the content below it. */}
      <div className="container container-responsive">
        <div className={styles.headerTitleSection}>
          <span className={styles.title}>
            Comparing Changes
          </span>
          <StopComparing />
        </div>
        Compare:
      </div>
    </header>
  );
};

export default ComparisonHeader;
